export default "__VITE_ASSET__B6a1vXN3__"